import gql from 'graphql-tag'
import { EntityFields, EnumFields } from '..'

export const BonusTypeFragment = gql`
  fragment BonusType on sales_bonus_type{
    ${EntityFields}
    ${EnumFields}
  }
`
